import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

//Healthscale img
import breathing_grey from '../../Images/Healthform/health_grey.png';
import breathing_green from '../../Images/Healthform/health_green.png';

class NivBreathingRateResDisplay extends Component {
    //Function to display form res alert logo with the good color
    getFormResImg(){
        let unit = ""
        if (this.props.breathingRateNivDisplay.res !== undefined && this.props.breathingRateNivDisplay.res !== "-"){
            unit = <FormattedMessage id="patientConstants.breathingRateUnit" defaultMessage="" />
        }

            return (
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"1%"}}>
                <Col style={{ width:"100%" }}>
                    <FormattedMessage id="patientConstants.breathingRate" defaultMessage="" />
                </Col>
                <Col style={{ width:"100%" }}>
                    <span id="row-measure-style" style={{color: this.props.breathingRateNivDisplay.color}}>{this.props.breathingRateNivDisplay.res}</span>
                    <span id="row-unit-style" style={{color: this.props.breathingRateNivDisplay.color}}>{unit}</span>
                </Col>
                </Row>
            )
    }

    display_value(){

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getFormResImg()
                }
            </Row>
        )
    }    

    //Display render
    render(){

        return (
            <div>
                {(this.props.alert) ?
                    <Col style={{backgroundColor: "yellow"}}>
                        {this.display_value()}
                    </Col>
                    :
                    <Col>
                        {this.display_value()}
                    </Col>
                }
            </div>
        );
    }
}
export default (NivBreathingRateResDisplay);